
import { Component } from 'react'
import { Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Row } from 'reactstrap'
import AddNewIncidentModal from './IncidentModals/AddNewIncidentModal'
import BulkIncidentActionModal from './BulkIncidentActionModal'
import TableColumnPreferenceControl from '../Material/TableColumnPreferenceControl'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'

class IncidentActions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            selectedBulkAction: "",
            actionsDropdownOpen: false,
        }
    }

    toggleModal = (modalName) => {
        this.setState({
            openModal: this.state.openModal === modalName ? "" : modalName,
            selectedBulkAction: modalName ? this.state.selectedBulkAction : "",
        })
    }

    toggleActionsDropdown = () => {
        this.setState({ actionsDropdownOpen: !this.state.actionsDropdownOpen })
    }

    openBulkAction = (actionType) => {
        this.setState({ openModal: "BulkIncidentAction", selectedBulkAction: actionType })
    }

    handleAssignmentRefetch = () => {
        const refetchResult = this.props.refetchQuery ? this.props.refetchQuery() : null
        if (this.props.clearSelectedIncidents) {
            this.props.clearSelectedIncidents()
        }
        return refetchResult
    }

    render() {
        const selectedIncidentsCount = this.props.selectedIncidents?.length || 0

        return (
            <Row>
                {this.state.openModal === "BulkIncidentAction" &&
                    <BulkIncidentActionModal
                        open={this.state.openModal === "BulkIncidentAction"}
                        actionType={this.state.selectedBulkAction}
                        incidentIds={(this.props.selectedIncidents || []).map(incident => incident.id)}
                        handleClose={() => this.toggleModal("")}
                        refetchQuery={this.handleAssignmentRefetch}
                    />
                }
                <Col xs={12} className="text-right mt-3">
                    {selectedIncidentsCount > 0 && <>
                        <Dropdown isOpen={this.state.actionsDropdownOpen} toggle={this.toggleActionsDropdown} className="d-inline-block">
                            <DropdownToggle tag="a" className="driver-list-button" caret>
                                Actions
                            </DropdownToggle>
                            <DropdownMenu right>
                                <DropdownItem onClick={() => this.openBulkAction("ASSIGN_REP")}>Assign Reps</DropdownItem>
                                <DropdownItem onClick={() => this.openBulkAction("UNASSIGN_REP")}>Unassign Reps</DropdownItem>
                                <DropdownItem onClick={() => this.openBulkAction("CHANGE_STATUS")}>Change Status</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>&nbsp;&nbsp;&nbsp;
                    </>}
                    <TableColumnPreferenceControl
                        tableId={this.props.tableId}
                        columnConfig={this.props.columnConfig}
                        setColumnConfig={this.props.setColumnConfig}
                        defaultColumnConfig={this.props.defaultColumnConfig}
                    />&nbsp;&nbsp;&nbsp;
                    {/* <a id="createNewIncident" className="driver-list-button" onClick={() => this.toggleModal("createNewIncident")}>
                        CREATE | <i className="fa fa-plus" aria-hidden="true"></i>
                    </a>&nbsp;&nbsp;&nbsp;
                    {this.state.openModal === "createNewIncident" &&
                        <AddNewIncidentModal
                            isOpen={this.state.openModal === "createNewIncident"}
                            toggle={() => this.toggleModal("")}
                            refetchQuery={this.props.refetchQuery}
                        />
                    } */}
                </Col>
            </Row>
        )
    }
}


export default IncidentActions
